module.exports = __webpack_public_path__ + "static/media/slide2.f6657687.jpg";